import { Routes } from '@angular/router';
import { AuthGuard } from './auth.guard';
import { HomeComponent } from './features/home/home.component';
import { DatenschutzComponent } from './core/datenschutz/datenschutz.component';
import { ImpressumComponent } from './core/impressum/impressum.component';
import { AboutUsComponent } from './core/about-us/about-us.component';
import { SaisonkalenderComponent } from './features/saisonkalender/saisonkalender.component';
import { NotFoundComponent } from './core/not-found/not-found.component';
import { blogDetailResolver } from './features/blog/blog-detail/blog-detail.resolver';

export const routes: Routes = [
  // Sofort geladene Komponenten für wichtige Seiten
  { path: '', component: HomeComponent },

  // Core Routen gruppieren
  {
    path: '',
    children: [
      { path: 'impressum', component: ImpressumComponent },
      { path: 'datenschutz', component: DatenschutzComponent },
      { path: 'ueber-uns', component: AboutUsComponent },
      { path: 'kraeuter-saisonkalender', component: SaisonkalenderComponent }
    ]
  },

  // Auth als eigenes Chunk
  {
    path: 'auth',
    loadComponent: () => import('./core/auth/auth.component')
      .then(m => m.AuthComponent)
  },

  // Blog als eigenes Chunk
  {
    path: 'blog',
    loadComponent: () => import('./features/blog/blog-overview/blog-overview.component')
      .then(m => m.BlogOverviewComponent)
  },
  {
    path: 'blog/:slug',
    loadComponent: () => import('./features/blog/blog-detail/blog-detail.component')
      .then(m => m.BlogDetailComponent),
    resolve: {
      blogResolved: blogDetailResolver
    },
    // Sicherstellen, dass der Resolver bei Param-Änderungen erneut ausgeführt wird
    runGuardsAndResolvers: 'paramsOrQueryParamsChange'
  },

  {
    path: 'kraeuter-lexikon',
    loadComponent: () => import('./features/kraeuter-lexikon/kraeuter-lexikon.component')
      .then(m => m.KraeuterLexikonComponent)
  },

  // Dashboard-Komponenten direkt auf Top-Level
  { 
    path: 'dashboard', 
    canActivate: [AuthGuard],
    loadComponent: () => import('./core/dashboard/dashboard.component')
      .then(m => m.DashboardComponent)
  },
  { 
    path: 'blog-manager', 
    canActivate: [AuthGuard],
    loadComponent: () => import('./core/dashboard/blog-manager/blog-manager.component')
      .then(m => m.BlogManagerComponent)
  },
  { 
    path: 'image-manager', 
    canActivate: [AuthGuard],
    loadComponent: () => import('./core/dashboard/image-manager/image-manager.component')
      .then(m => m.ImageManagerComponent)
  },
  { 
    path: 'product-manager', 
    canActivate: [AuthGuard],
    loadComponent: () => import('./core/dashboard/product-manager/product-manager.component')
      .then(m => m.ProductManagerComponent)
  },
  { 
    path: 'blog-creator-ai', 
    canActivate: [AuthGuard],
    loadComponent: () => import('./features/blog/blog-creator-ai/blog-creator-ai.component')
      .then(m => m.BlogCreatorAiComponent)
  },
  { 
    path: 'blog-editor/:id',
    canActivate: [AuthGuard],
    loadComponent: () => import('./features/blog/blog-editor/blog-editor.component')
      .then(m => m.BlogEditorComponent)
  },

  // Dynamische und Wildcard-Routen
  { 
    path: ':category/:slug', 
    loadComponent: () => import('./features/info-detail/info-detail.component')
      .then(m => m.InfoDetailComponent)
  },

  //  Echte 404-Komponente rendern, kein Redirect
  { path: '**', component: NotFoundComponent }
];
